import placeholderUrl from '@assets/images/placeholder.png';
import { formatCurrency } from '@helpers';
import { HawksearchGlobal, SearchResultsItem } from '@models';
import { trackingService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './featured-items-content-item.component.hbs';

declare let Hawksearch: HawksearchGlobal;

export class FeaturedItemsContentItemComponent extends BaseComponent<SearchResultsItem> {
    protected override bindEvent = undefined;
    protected override customTemplatePropertyName = 'featuredItemsContentItem';
    protected override defaultHtml = defaultHtml;

    protected override registerHelpers(): void {
        super.registerHelpers();

        this.handlebars.registerHelper('string', (values: string | Array<string> | undefined, defaultValue?: string): string | undefined => {
            if (typeof values === 'string') {
                values = [values];
            }

            return this.getString(values, defaultValue);
        });

        this.handlebars.registerHelper('number', (values: string | Array<string> | undefined, defaultValue?: number): number | undefined => {
            if (typeof values === 'string') {
                values = [values];
            }

            return this.getNumber(values, defaultValue);
        });

        this.handlebars.registerHelper('currency', (values: number | Array<string> | undefined, defaultValue?: number): string | undefined => {
            if (typeof values === 'string') {
                values = [values];
            } else if (typeof values === 'number') {
                values = [values.toString()];
            }

            return this.getCurrency(values, defaultValue);
        });
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-image]').forEach((e) => {
            e.addEventListener('error', (event: Event): void => {
                const element = event.currentTarget as HTMLImageElement;

                element.src = Hawksearch.config.placeholderImageUrl || placeholderUrl;
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', ((event: PointerEvent): void => {
                if (!this.data) {
                    return;
                }

                trackingService.trackSearchResultClick(this.data.id, this.data.url, event);
            }) as EventListener);
        });
    }

    private getString(values: Array<string> | undefined, defaultValue?: string): string | undefined {
        return values?.[0] ?? defaultValue;
    }

    private getNumber(values: Array<string> | undefined, defaultValue?: number): number | undefined {
        const string = this.getString(values);
        let value = string ? parseFloat(string) : undefined;

        if (value !== undefined && isNaN(value)) {
            value = undefined;
        }

        return value ?? defaultValue;
    }

    private getCurrency(values: Array<string> | undefined, defaultValue?: number): string | undefined {
        const value = this.getNumber(values) || defaultValue;

        if (!value) {
            return undefined;
        }

        return formatCurrency(value);
    }
}
